// Utils
import { createStateMachine } from '../../createStateMachine';
import { getFetchStateTransitions } from './getFetchStateTransitions';
import { FetchStates } from '../types/FetchStates';
/**
 * @description Returns a state machine that handles fetch with pagination.
 *
 * @param {CreateFetchStateMachineProps} props - The properties for creating the fetch state machine.
 * @returns {StateMachine<FetchStates, FetchActions, FetchContext>} The created fetch state machine.
 * @see {@link https://stately.ai/viz/d5231be1-4cdc-441a-9327-f99f1e7df75a}
 */
export var createFetchStateMachine = function (_a) {
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure, onAbort = _a.onAbort;
    return createStateMachine({
        initialState: FetchStates.IDLE,
        stateTransitions: getFetchStateTransitions({ onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }),
        initialContext: {}
    });
};
//# sourceMappingURL=createFetchStateMachine.js.map